import { blobSaveAndUpload } from '../../../app-core/lib/upload/blobSaveAndUpload'
import { allFileExtensions } from '../../../shared/domain/files/fileExtensions.no-deps'
import { generateFileId } from '../../../shared/domain/files/types.no-deps'
import { appUploadQueue } from './AppUploadQueue'
import { writeArrayBufferToDisk } from './writeArrayBufferToDisk'
import type { UploadGroupId } from '../../../app-core/lib/upload/Upload'
import { Base_commonDeps } from '../Base/Base.commonDeps'
import { E2E_waitForResumeSaveBlob } from '../E2E/E2E.listener'

export async function saveBlob(groupId: UploadGroupId, blob: Blob, customer: number) {
    if (window.E2E_PauseSaveBlob) await E2E_waitForResumeSaveBlob()

    return blobSaveAndUpload({
        fileId: generateFileId(),
        blob,
        deps: Base_commonDeps(),
        acceptedExtensions: allFileExtensions,
        groupId,
        writeArrayBufferToDisk,
        uploadQueue: appUploadQueue,
        customer,
    })
}
